export default __webpack_public_path__ + "static/cardsRowImg3-410393d2fe9768447da113f5c811f5e2.png";